import { render } from "./IIC30PercentView.vue?vue&type=template&id=5105cfd5"
import script from "./IIC30PercentView.vue?vue&type=script&lang=js"
export * from "./IIC30PercentView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__